<template>
  <h3 class="truncate text-left text-base font-semibold text-headline">
    <slot></slot>
  </h3>
</template>
